import { useEmbarcacaoConsumoOperacao } from "../../../../hooks/use-embarcacao-consumo-operacao";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  CONSUMO_OPERACAO_EMPTY_STATE,
  CONSUMO_OPERACAO_FIELDS,
  CONSUMO_OPERACAO_ID,
  CONSUMO_OPERACAO_LOADING_MESSAGE,
  CONSUMO_OPERACAO_TEST_ID,
  CONSUMO_OPERACAO_TITLE,
} from "./consumo-operacao-section.constants";

/** Seção Consumo Modo Operação do detalhamento da embarcação, somente para consulta: campos já formatados na ordem da tela; campo sem valor mostra "Campo sem preenchimento". */
export function useConsumoOperacaoSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, consumo, errorMessage, reload } = useEmbarcacaoConsumoOperacao(embarcacaoId);

  return {
    id: CONSUMO_OPERACAO_ID,
    title: CONSUMO_OPERACAO_TITLE,
    testId: CONSUMO_OPERACAO_TEST_ID,
    fieldsTestId: `${CONSUMO_OPERACAO_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: CONSUMO_OPERACAO_LOADING_MESSAGE,
    emptyContent: CONSUMO_OPERACAO_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: consumo
      ? latestAtualizacao([consumo.ultimaAtualizacao, consumo.atualizacaoConsumo])
      : undefined,
    fields: buildDetailFields(
      consumo,
      CONSUMO_OPERACAO_FIELDS,
      CONSUMO_OPERACAO_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ),
  };
}
